import * as React from 'react';

export const SpoonPlateIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
    <path
      stroke="#693EB5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M4 19v-9m0 0c1.657 0 3-2.015 3-4.5S5.657 1 4 1 1 3.015 1 5.5 2.343 10 4 10m15 9a9 9 0 0 1 0-18m0 14a5 5 0 1 1 0-10"
    />
  </svg>
);

export default SpoonPlateIcon;
